// Modern style imports
import Modern0 from './layouts/modern/0.jsx'
import Modern1 from './layouts/modern/1.jsx'
import Modern2 from './layouts/modern/2.jsx'
import Modern3 from './layouts/modern/3.jsx'

// Classic style imports
import Classic0 from './layouts/classic/0.jsx'
import Classic1 from './layouts/classic/1.jsx'
import Classic2 from './layouts/classic/2.jsx'
import Classic3 from './layouts/classic/3.jsx'
import Classic4 from './layouts/classic/4.jsx'
import Classic5 from './layouts/classic/5.jsx'
// // Bold style imports
import Bold0 from './layouts/bold/0.jsx'
import Bold1 from './layouts/bold/1.jsx'
import Bold2 from './layouts/bold/2.jsx'
import Bold3 from './layouts/bold/3.jsx'

// // Playful style imports
import Playful0 from './layouts/playful/0.jsx'
import Playful1 from './layouts/playful/1.jsx'
import Playful2 from './layouts/playful/2.jsx'
import Playful3 from './layouts/playful/3.jsx'

// // Professional style imports
import Professional0 from './layouts/professional/0.jsx'
import Professional1 from './layouts/professional/1.jsx'
import Professional2 from './layouts/professional/2.jsx'
import Professional3 from './layouts/professional/3.jsx'

// Icon mapping object
export const iconMap = {
  modern: {
    0: { default: Modern0 },
    1: { default: Modern1 },
    2: { default: Modern2 },
    3: { default: Modern3 }
  },
  classic: {
   
    0: { default: Classic2 },
    1: { default: Classic3 },
    2: { default: Classic4 },
    3: { default: Classic5 },
    4: { default: Classic0 },
    5: { default: Classic1 },
  },
  bold: {
    0: { default: Bold0 },
    1: { default: Bold1 },
    2: { default: Bold2 },
    3: { default: Bold3 }
  },
  playful: {
    0: { default: Playful0 },
    1: { default: Playful1 },
    2: { default: Playful2 },
    3: { default: Playful3 }
  },
  professional: {
    0: { default: Professional0 },
    1: { default: Professional1 },
    2: { default: Professional2 },
    3: { default: Professional3 }
  }
}
